import {
    CREATEINCOMEHEAD,
    GETINCOMEHEAD,
    UPDATEINCOMEHEAD,
    DELETEINCOMEHEAD,
    CREATEEXPENSEHEAD,
    GETEXPENSEHEAD,
    UPDATEEXPENSEHEAD,
    DELETEEXPENSEHEAD,

} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEINCOMEHEAD:
            return {
                ...state,
                incomeheadSaveStatus: action.payload.success,
            }
        case GETINCOMEHEAD:
                return {
                        ...state,
                        incomeheadList: action.payload.data,
                        }
        case UPDATEINCOMEHEAD:
                return {
                        ...state,
                        incomeheadUpdateStatus: action.payload.success,
                        }   

        case DELETEINCOMEHEAD:
                return {
                     ...state,
                     incomeheadDeleteStatus: action.payload.success,
                        } 
        case CREATEEXPENSEHEAD:
                return {
                        ...state,
                        expenseheadSaveStatus: action.payload.success,
                        }
        case GETEXPENSEHEAD:
                return {
                        ...state,
                        expenseheadList: action.payload.data,
                        }
        case UPDATEEXPENSEHEAD:
                return {
                         ...state,
                        expenseheadUpdateStatus: action.payload.success,
                        }   
                
        case DELETEEXPENSEHEAD:
                                 return {
                                     ...state,
                                     incomeheadDeleteStatus: action.payload.success,
                                        } 
                        default:
                            return state
                                  }
                             }